import BreadCrumbs from "components/widgets/bread-crumbs";
import SideNav, { ISideNavRoutes } from "./side-nav";
import TopNav from "./top-nav";
import { BiHomeSmile } from "react-icons/bi";
import { VscGraphLine } from "react-icons/vsc";
import { RiUser3Line, RiBankLine } from "react-icons/ri";
import { CgTerminal } from "react-icons/cg";

function DashBoardLayout({ children }: { children: JSX.Element }) {
  const routes: ISideNavRoutes[] = [
    {
      display: "Home",
      path: "/home",
      icon: <BiHomeSmile />,
      exact: true,
    },

    {
      display: "Usage",
      path: "/home/usage",
      icon: <VscGraphLine />,
      exact: true,
    },
    {
      display: "Logs",
      path: "/home/my",
      icon: <CgTerminal />,
      exact: true,
    },

    {
      display: "Payments",
      path: "/home/payments",
      icon: <RiBankLine />,
      exact: true,
    },
    {
      display: "Profile",
      path: "/home/profile",
      icon: <RiUser3Line />,
      exact: true,
    },
  ];

  return (
    <>
      <TopNav />
      <div className="grid grid-cols-12 h-screen w-screen pt-16">
        <SideNav routes={routes} className="col-span-2 sm:col-span-1 md:col-span-3 lg:col-span-2 " />
        <main className="col-span-10 sm:col-span-11 md:col-span-9 lg:col-span-10 overflow-y-scroll">
          <BreadCrumbs />

          {children}
        </main>
        {/* <RightBar className="hidden xl:flex xl:col-span-2" /> */}
      </div>
    </>
  );
}

export default DashBoardLayout;
